import React, { useState, useEffect } from 'react';
import  { Container, Row, Col, Button, Card, Breadcrumb, Modal, Form } from 'react-bootstrap';
import {  useNavigate, useLocation } from 'react-router-dom';
import Header from '../page-layout/header/Header';
import NavMenu from '../navigation/Navmenu';
import Footer from '../page-layout/footer/Footer';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { GetMyChallenges } from '../../utils/axios/MyChallengesAPI';
import { Decrypt } from '../../utils/Helper';
import { handleDownload } from '../../utils/axios/ChallengesAPI';
import { GetMyChallengesById } from '../../utils/axios/MyChallengesAPI';
import { GrokLoading } from '../page-layout/loading/Loading';
import moment from 'moment';
import { Margin, usePDF } from "react-to-pdf";

const MyChallenges = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [userInfo, setuserInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
    const [edit, setEdit] = useState(false);
    const [view, setView] = useState(false);
    const [status, setStatus] = useState();
    const [ data, setData ] = useState();
    const ref = React.createRef();
    const [loading, setLoading] = useState(true);

    const [name, setName] = useState('');
    const [collegeName, setCollegeName] = useState('');
    const [challengeName, setChallengeName] = useState('');
    const [registeredDate, setRegisteredDate] = useState('');
    const [submittedDate, setSubmittedDate] = useState('');
    const [availableComponents, setAvailableComponents] = useState('');
    const [additionalComponents, setAdditionalComponents] = useState('');
    const [projectBrief, setProjectBrief] = useState('');
    const [solution, setSolution] = useState('');
    const [circuitDiagram, setCircuitDiagram] = useState('');
    const [pythonCode, setPythonCode] = useState('');
    const [feedBack, setFeedback] = useState('');
    const toggleStatus = () => {
        setStatus(!status);
    };

    const columns = [
        {
          name: "Participant Name",
          selector:  row => row.StudentId.DisplayName,
          sortable:true,
          cell: row => row.StudentId.DisplayName,
        },
        {
          name: "Associate College",
          selector:  row => row.OrganizationId?.name ? row.OrganizationId?.name : 'NA',
          sortable:true,
          cell: row => row.OrganizationId?.name ? row.OrganizationId?.name : 'NA',
        },
        {
          name: "Use Case Name",
          selector:  row => row.ChallengeId == null ? '' : row.ChallengeId.name,
          sortable:true,
          cell: row => row.ChallengeId.name,
        },
        {
            name: "Actions",
            width: "250px",
            cell: (row) => (<>
                {!row.Solution &&<button className="btn btn-link" title="Post Your Solution" onClick={() => addMyChallenges(row._id, row.ChallengeId.id)}><span><svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg></span></button>}
                {row.Solution && <button className="btn btn-link" title="View submitted details" onClick={() => handleMyChallengesShow(row._id)}><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M255.66 112c-77.94 0-157.89 45.11-220.83 135.33a16 16 0 00-.27 17.77C82.92 340.8 161.8 400 255.66 400c92.84 0 173.34-59.38 221.79-135.25a16.14 16.14 0 000-17.47C428.89 172.28 347.8 112 255.66 112z"></path><circle cx="256" cy="256" r="80" fill="none" strokeMiterlimit="10" strokeWidth="32"></circle></svg></span></button>}
                {/* <button className="btn btn-link" title="Pdf Download" onClick={() => handleShow(row.title, row.description)}><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"></path></svg></span></button> */}
            </>),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
      ];

    const tableData = {
        columns,
        data
    };

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = (title, description) => {
        setShow(true);
        
        setTimeout(() => {
            document.getElementById('Title').innerText = title;
            document.getElementById('Description').innerText = description
        }, 10);
    }

    const [myChallengeShow, setMyChallengeShow] = useState(false);
    const handleMyChallengesClose = () => {
        setMyChallengeShow(false);
        setName('');
        setCollegeName('');
        setChallengeName('');
        setRegisteredDate('');
        setSubmittedDate('');
        setAvailableComponents('');
        setAdditionalComponents('');
        setProjectBrief('');
        setCircuitDiagram('');
        setPythonCode('');
        setSolution('');
        setFeedback('');
    }
    const handleMyChallengesShow = async(id) => {
        setMyChallengeShow(true);
        setLoading(true);
        var myChallengesResponse = await GetMyChallengesById(id);
        setLoading(false);
        setName(myChallengesResponse.data[0].StudentId.DisplayName);
        setCollegeName(myChallengesResponse.data[0].StudentId.OrganizationId.name);
        setChallengeName(myChallengesResponse.data[0].ChallengeId.name);
        setRegisteredDate(moment(myChallengesResponse.data[0].CreatedDate).format('DD/MM/YYYY'));
        setSubmittedDate(moment(myChallengesResponse.data[0].SubmissionDate).format('DD/MM/YYYY'));
        setAvailableComponents(myChallengesResponse.data[0].AvailableComponents);
        setAdditionalComponents(myChallengesResponse.data[0].AdditionalComponents);
        setPythonCode(myChallengesResponse.data[0].PythonCode);
        setCircuitDiagram(myChallengesResponse.data[0].CircuitDiagram);
        setSolution(myChallengesResponse.data[0].Solution);
        setProjectBrief(myChallengesResponse.data[0].ProjectBrief);
        setFeedback(myChallengesResponse.data[0].Feedback);
    };

    const addMyChallenges = (id, challengeid) => {
      navigate('/myindustryusecasedetails',  {state: {myChallengeid: id, challengeid: challengeid}});
    }

    const BackBtn = () => {
        navigate('/home');
    }
    
    const addRefresh = () => {
        navigate('/home', {state: {myChallengeid: null}});
    }

    const { toPDF, targetRef } = usePDF({
        filename: (`${name}-${challengeName}`),
        page: { margin: Margin.MEDIUM }
    });

    const getMyChallenges = async () =>{
        let getMyChallengesPayload = {
            StudentId: userInfo.StudentId
        }
        setLoading(true);
        var myChallengesResponse = await GetMyChallenges(getMyChallengesPayload);
        setLoading(false);
        setData(myChallengesResponse.data);
    }

    const openSubmittedDetail = () => {
        if (location.state && location.state?.challengeid != null) {
            handleMyChallengesShow(location.state.challengeid);
            
        const newState = { ...location.state };
        delete newState.challengeid;

        // Replace the current location with the updated state
        navigate(location.pathname, { state: newState, replace: true });
        }
        else {
            //
        }
    }
    useEffect(() => {
        openSubmittedDetail();
        getMyChallenges();
        // document.querySelectorAll(".navbar-nav .nav-item a")[3].classList.add("active")
    }, []);


    return (
        <div className='page'>
        {loading ? <GrokLoading /> : ""}
            <NavMenu />
            <Header />
            <div className='page-wrapper'>
                <Container fluid>
                    {/* Start Page Header */}
                    <div className='page-header d-print-none'>
                        <Row className='g-2 align-items-center pb-1'>
                            <div>
                                <Breadcrumb className="custom-breadcrumb">
                                    <Breadcrumb.Item  onClick={() => addRefresh()}>Home</Breadcrumb.Item>
                                    <Breadcrumb.Item active>My Industry Use Cases</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <Col style={{ display: 'flex', alignItems: 'center' }}>
                                <Button className='nave-icon' variant='outline' size='sm' title='MyChallenges'>
                                    <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M22 5.18L10.59 16.6l-4.24-4.24 1.41-1.41 2.83 2.83 10-10L22 5.18zM12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8c1.57 0 3.04.46 4.28 1.25l1.45-1.45A10.02 10.02 0 0012 2C6.48 2 2 6.48 2 12s4.48 10 10 10c1.73 0 3.36-.44 4.78-1.22l-1.5-1.5c-1 .46-2.11.72-3.28.72zm7-5h-3v2h3v3h2v-3h3v-2h-3v-3h-2v3z"></path></svg></span>
                                </Button>
                                <h2 className="page-title"> My Industry Use Cases</h2>
                            </Col>
                            <Col className="mb-1 me-3 col-md-auto">
                                <button className='newBtn_style' onClick={() => BackBtn()}>
                                    <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg></span>
                                    &nbsp;&nbsp;Back
                                </button>
                            </Col>
                        </Row>
                    </div>
                    {/* End Page Header */}
                    <div className='py-3'>
                        <div className='card mb-3 mb-lg-5 '>
                            {/* Header */}
                            <div className='card-header'>
                                <Row className="row justify-content-between align-items-center flex-grow-1">
                                    <Col className='col-md mb-2 md-mb-0'>
                                        <div className="d-flex justify-content-between align-items-center">
                                            {/* <div className="card-title fw-bold mb-0">My Challenges list</div> */}
                                        </div>
                                    </Col>
                                    {/* End Col */}
                                    <Col className='col-12 col-md-auto ms-auto d-print-none'>
                                        {/* <div className="form-group position-relative">
                                            <form className="d-flex mb-2 mb-md-0">
                                                <div className="form-group position-relative">
                                                    <input className="form-control leftpadding" id="text" variant="outlined" placeholder='Students Challenges' onChange={handleName} />
                                                </div>
                                            </form>
                                        </div> */}
                                    </Col>
                                </Row>
                                {/* End Row */}
                            </div>
                            <div className='taablist'>
                              <DataTableExtensions {...tableData}>
                                  <DataTable
                                      columns={columns}
                                      data={data}
                                      fixedHeader
                                      defaultSortField="id"
                                      defaultSortAsc={false}
                                      pagination
                                      paginationPerPage={20}
                                      paginationRowsPerPageOptions={[20, 30, 50, 100]}
                                  />
                              </DataTableExtensions>
                            </div>
                        </div>
                    </div>
                    
                    <div>
                        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} className="model-popup" aria-labelledby="contained-modal-title-vcenter" centered>
                        <Modal.Header closeButton>
                            <Modal.Title><b>Challenge Description</b> </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div>
                                <Row className="align-items-center">
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                <div id='Title'>Challenge Title</div>
                                            </Form.Label>
                                            <div className="col">
                                                <div className='small' id='Description'>Description</div>
                                            </div>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </div>
                        </Modal.Body>
                        </Modal>
                    </div>

                    <div>
                        <Modal show={myChallengeShow} onHide={handleMyChallengesClose} size="xl" backdrop="static" keyboard={false} className="model-popup" aria-labelledby="contained-modal-title-vcenter" centered>
                        {loading ? <GrokLoading /> : ""}
                        <Modal.Header closeButton>
                            <Modal.Title><b>Project Report</b> </Modal.Title>
                            <div className='mx-5'>
                                <button className="downloadBtn" x={30} onClick={toPDF} title="Download pdf">
                                    <span className='mx-1'><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z"></path></svg>&nbsp;
                                        Download
                                    </span>
                                </button>
                            </div>
                        </Modal.Header>
                        <div ref={targetRef}>
                            <Modal.Body>
                                <div>
                                    <Row className="g-2 justify-content-center">
                                        <Col className="col-lg-10 mb-4">
                                            <Row className="studentdata-view">
                                                <Col lg={12} className="mb-4">
                                                    <div className="fw-bold studhead mb-3 pb-2">
                                                        <span>Project Details</span>
                                                    </div>
                                                    <Row className="mb-1">
                                                        <Col xs={6}><p>Name</p></Col>
                                                        <Col xs={6}> <p> <b>{name}</b> </p></Col>
                                                    </Row>
                                                    <Row className="mb-1">
                                                        <Col xs={6}><p>College Name</p></Col>
                                                        <Col xs={6}> <p> <b>{collegeName}</b> </p></Col>
                                                    </Row>
                                                    <Row className="mb-1">
                                                        <Col xs={6}> <p>Challenge Name</p> </Col>
                                                        <Col xs={6}> <p> <b>{challengeName}</b> </p></Col>
                                                    </Row>
                                                    <Row className="mb-1">
                                                        <Col xs={6}> <p>Registered Date</p> </Col>
                                                        <Col xs={6}> <p> <b>{registeredDate}</b> </p> </Col>
                                                    </Row>
                                                    <Row className="mb-1">
                                                        <Col xs={6}> <p>Submitted Date</p> </Col>
                                                        <Col xs={6}> <p> <b>{submittedDate}</b> </p> </Col>
                                                    </Row>
                                                </Col>
                                                <Col lg={12} className="mb-4">
                                                    <div className="fw-bold studhead mb-3 pb-2">
                                                        <span>Submitted Details</span>
                                                    </div>
                                                    <Row className="mb-1">
                                                        <Col xs={6}> <p>Available Components</p> </Col>
                                                        <Col xs={6}> <p> <b>{availableComponents} </b> </p> </Col>

                                                            <Col xs={6}> <p>Additional Components</p> </Col>
                                                            <Col xs={6}> <p> <b>{additionalComponents}</b> </p> </Col>

                                                        <Col xs={6}> <p>Solution</p> </Col>
                                                        <Col xs={6}> <p> <b>{solution}</b> </p> </Col>

                                                        <Col xs={6}> <p>ProjectBrief</p> </Col>
                                                        <div className='ms-4'> <p> <b>{projectBrief}</b> </p> </div>

                                                        <Col xs={6}> <p>Feedback</p> </Col>
                                                        <div className='ms-4'> <p> <b>{feedBack}</b> </p> </div>
                                                    </Row>
                                                </Col>
                                                {(circuitDiagram !== 'null') && <Col lg={12} className="mb-4">
                                                    <div className="fw-bold studhead mb-3 pb-2">
                                                        <span>Circuit Diagram</span>
                                                    </div>
                                                    <Row className="mb-1">
                                                        <div className='ms-4'>
                                                            <img className="img-w-h img-fluid" alt='circuit diagram' src={circuitDiagram} />
                                                        </div>
                                                    </Row>
                                                </Col>}
                                                {(pythonCode !== 'null') && <Col lg={12} className="mb-4">
                                                    <div className="fw-bold studhead mb-3 pb-2">
                                                        <span>Python Program</span>
                                                    </div>
                                                    <Row className="mb-1">
                                                        <div className='ms-2'>
                                                            <img className="img-w-h img-fluid" alt='python code' src={pythonCode} />
                                                        </div>
                                                    </Row>
                                                </Col>}
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                            </Modal.Body>
                        </div>
                        </Modal>
                    </div>
                </Container>
                <Footer />
            </div>
        </div>
    )
}

export default MyChallenges; 